


























import { CitationSearchParams } from './CitationSearch/CitationSearchParams';
import { SearchPayload } from '@/Stores/CitationStore';
import constants from '@/constants';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';

export default mixins(LocationBasedMixin).extend({
    name: 'citation-root',
    computed: {
        searchParams() {
            return this.$typedStore.modules.citationModule.getters.searchParams;
        },
    },
    methods: {
        async search() {
            if (!this.searchParams.citationNumber) {
                return;
            }

            const payload: SearchPayload = {
                parameters: this.searchParams,
                location: this.$typedStore.state.currentLocation
            };
            this.$typedStore.modules.citationModule.actions.beginSearch(payload);
            this.$router.push({
                name: 'citationSearchResults', params: { location: this.location }
            });
        }
    }
});
